import { cx } from "@emotion/css";
import { useTranslation } from "react-i18next";
import { FolderEmptyItem } from "src/components/Folders/FolderEmptyItem";
import { FolderItemsSection } from "src/components/Folders/FolderItemsSection";
import { FolderSelectionCheckbox } from "src/components/Folders/FolderSelectionCheckbox";
import type { FolderPreviewProps } from "src/components/Folders/types";
import { useModals } from "src/components/Modals/context/ModalProvider";
import { ModalsNames } from "src/components/Modals/context/modals";
import { NoteCardView, type NoteRow } from "src/components/Notes/NoteCardView";

export const FolderNotesPreview = ({
	folderId,
	folderName,
	items,
	isSelectMode,
	selectedItems,
	toggleSelection,
}: FolderPreviewProps) => {
	const { t } = useTranslation();
	const { openModal } = useModals();

	return (
		<FolderItemsSection
			title={t("folder.tabs.notes", "Notatki")}
			type="note"
			folderId={folderId}
			isVisible={true}
		>
			{items?.map((item) => {
				const isSelected =
					isSelectMode &&
					selectedItems?.some(
						(i) => i.itemId === item.data?.id && i.itemType === "note",
					);

				return (
					<div
						key={item.id}
						data-test-id="folder-note-item"
						data-note-id={item.data?.id}
						onClick={
							isSelectMode
								? () => toggleSelection(item.data, "note", item.id)
								: undefined
						}
						className={cx(isSelectMode && "cursor-pointer p-relative")}
					>
						{isSelectMode && (
							<FolderSelectionCheckbox isSelected={!!isSelected} />
						)}
						<NoteCardView
							row={item.data as NoteRow}
							folderId={folderId}
							className={cx(
								"mb-0 w-100 min-w-350",
								isSelected && "border-color-primary",
								isSelectMode && "pointer-events-none",
							)}
						/>
					</div>
				);
			})}
			{(items?.length ?? 0) < 3 && (
				<FolderEmptyItem
					className="h-100-important"
					onClick={() => {
						openModal(ModalsNames.AddFolderContentModal, {
							folderId,
							folderName,
							initialTab: "note",
						});
					}}
				/>
			)}
		</FolderItemsSection>
	);
};
